
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiParametriGlobaliGrid extends Serenity.EntityGrid<ProdottiParametriGlobaliRow, any> {
        protected getColumnsKey() { return ProdottiParametriGlobaliColumns.columnsKey; }
        protected getDialogType() { return ProdottiParametriGlobaliDialog; }
        protected getIdProperty() { return ProdottiParametriGlobaliRow.idProperty; }
        protected getInsertPermission() { return ProdottiParametriGlobaliRow.insertPermission; }
        protected getLocalTextPrefix() { return ProdottiParametriGlobaliRow.localTextPrefix; }
        protected getService() { return ProdottiParametriGlobaliService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}